import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import MsModal from "src/components/ms-common/ms-modal/MsModal";
import { ERROR_MESSAGE } from "src/common/constants";
import { AuthorizationActionTypes } from "./types";
import {
  fetchUserInfo,
  fetchUserInfoFinish,
  fetchUserInfoError,
  fetchSysParam,
  fetchSysParamFinish
} from "./actions";
import { fetchApi } from "../../utils/fetchApi";
import Tools from "src/utils/tools";

// 执行获取用户信息
function* handleFetchUserInfo(action: ReturnType<typeof fetchUserInfo>) {
  try {
    const res = yield call(fetchApi, "get", "salaryCpayCp/authority/verifyJusdUser");
    if (res) {
      yield put(fetchUserInfoFinish(res));
      yield put(fetchSysParam({})); // 数据类型,多个数据类型间以,分割 不传值则查询所有的数据, 要查询传{dataTypeDescs: "Operating, BizLine"}
    } else {
      yield put(fetchUserInfoError());
    }
  } catch (err) {
    yield put(fetchUserInfoError());
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 查询系统信息
function* handleFetchSysParam(action: ReturnType<typeof fetchSysParam>) {
  try {
    const p = Tools.appendParams("salaryCpayCp/systemParameter/search", action.payload);
    const res = yield call(fetchApi, "get", p);
    yield put(fetchSysParamFinish(res ? res.data : {}))
  } catch(err) {
    yield put(fetchSysParamFinish({}))
    MsModal.error({content: err instanceof Error ? err.stack! : ERROR_MESSAGE});
  }
}

// 监控，根据指定action类型，调用saga方法
function* watchFetchUserInfo() {
  yield takeEvery(AuthorizationActionTypes.FETCH_USER_INFO, handleFetchUserInfo);
  yield takeEvery(AuthorizationActionTypes.FETCH_SYS_PARAM, handleFetchSysParam);
}

// 合并所有saga监控
function* authorizationSaga() {
  yield all([fork(watchFetchUserInfo)]);
}

export default authorizationSaga;



// WEBPACK FOOTER //
// ./src/store/authorization/sagas.ts